import util from '../util';

export const SHOWROOM_LIST = 'SHOWROOM_LIST';
export const RECENT_DEAL_LIST = 'RECENT_DEAL_LIST';
export const ALL_DEALS = 'ALL_DEALS';
export const DEAL = 'DEAL';
export const CAR = 'CAR';
export const USER = 'USER';
export const DEALER = 'DEALER';
export const PENCIL = 'PENCIL';
export const PENCIL_CREATE = 'PENCIL_CREATE';
export const PENCIL_UPDATE = 'PENCIL_UPDATE';
export const PENCIL_CRM_PUSH = 'PENCIL_CRM_PUSH';
export const DEAL_UPDATE = 'DEAL_UPDATE';
export const DEAL_CREATE = 'DEAL_CREATE';
export const DEAL_TRADEINS_UPDATE = 'DEAL_TRADEINS_UPDATE';
export const ONLINE_DEAL_CREATE = 'ONLINE_DEAL_CREATE';
export const DEAL_CRM_PUSH = 'DEAL_CRM_PUSH';
export const DEAL_DMS_PUSH = 'DEAL_DMS_PUSH';
export const DEAL_DMS_PUSH_OFFER = 'DEAL_DMS_PUSH_OFFER';
export const SET_PRIMARY_CAR = 'SET_PRIMARY_CAR';
export const PAYMENTS = 'PAYMENTS';
export const SELECTED_CARS = 'SELECTED_CARS';
export const PRINT_STICKER = 'PRINT_STICKER';
export const SEND_STICKER = 'SEND_STICKER';
export const SET_DEAL_TRADEINS = 'SET_DEAL_TRADEINS';

export const FORWARD_TO_FNI = 'FORWARD_TO_FNI';

export const LOAD_DEAL_DATA = 'LOAD_DEAL_DATA';

export const FINANCE_RESPONSE_UPDATE = 'FINANCE_RESPONSE_UPDATE';

export const SHOWROOM_LIST_REQUEST = util.requestType(SHOWROOM_LIST);
export const SHOWROOM_LIST_SUCCESS = util.successType(SHOWROOM_LIST);
export const SHOWROOM_LIST_FAILURE = util.failureType(SHOWROOM_LIST);
export const SHOWROOM_LIST_POLLING_RESET = util.resetType(SHOWROOM_LIST);

export const RECENT_DEAL_LIST_REQUEST = util.requestType(RECENT_DEAL_LIST);
export const RECENT_DEAL_LIST_SUCCESS = util.successType(RECENT_DEAL_LIST);
export const RECENT_DEAL_LIST_FAILURE = util.failureType(RECENT_DEAL_LIST);

export const ALL_DEALS_REQUEST = util.requestType(ALL_DEALS);
export const ALL_DEALS_SUCCESS = util.successType(ALL_DEALS);
export const ALL_DEALS_FAILURE = util.failureType(ALL_DEALS);

export const DEAL_REQUEST = util.requestType(DEAL);
export const DEAL_SUCCESS = util.successType(DEAL);
export const DEAL_FAILURE = util.failureType(DEAL);

export const DEAL_UPDATE_REQUEST = util.requestType(DEAL_UPDATE);
export const DEAL_UPDATE_SUCCESS = util.successType(DEAL_UPDATE);
export const DEAL_UPDATE_FAILURE = util.failureType(DEAL_UPDATE);

export const FINANCE_RESPONSE_UPDATE_FAILURE = util.failureType(
  FINANCE_RESPONSE_UPDATE,
);

export const DEAL_TRADEINS_UPDATE_SUCCESS = util.successType(
  DEAL_TRADEINS_UPDATE,
);
export const DEAL_TRADEINS_UPDATE_FAILURE = util.failureType(
  DEAL_TRADEINS_UPDATE,
);

export const DEAL_CREATE_REQUEST = util.requestType(DEAL_CREATE);
export const DEAL_CREATE_SUCCESS = util.successType(DEAL_CREATE);
export const DEAL_CREATE_FAILURE = util.failureType(DEAL_CREATE);

export const ONLINE_DEAL_CREATE_REQUEST = util.requestType(ONLINE_DEAL_CREATE);
export const ONLINE_DEAL_CREATE_SUCCESS = util.successType(ONLINE_DEAL_CREATE);
export const ONLINE_DEAL_CREATE_FAILURE = util.failureType(ONLINE_DEAL_CREATE);

export const DEAL_CRM_PUSH_REQUEST = util.requestType(DEAL_CRM_PUSH);
export const DEAL_CRM_PUSH_SUCCESS = util.successType(DEAL_CRM_PUSH);
export const DEAL_CRM_PUSH_FAILURE = util.failureType(DEAL_CRM_PUSH);

export const DEAL_DMS_PUSH_REQUEST = util.requestType(DEAL_DMS_PUSH);
export const DEAL_DMS_PUSH_SUCCESS = util.successType(DEAL_DMS_PUSH);
export const DEAL_DMS_PUSH_FAILURE = util.failureType(DEAL_DMS_PUSH);

export const DEAL_DMS_PUSH_OFFER_REQUEST = util.requestType(
  DEAL_DMS_PUSH_OFFER,
);
export const DEAL_DMS_PUSH_OFFER_SUCCESS = util.successType(
  DEAL_DMS_PUSH_OFFER,
);
export const DEAL_DMS_PUSH_OFFER_FAILURE = util.failureType(
  DEAL_DMS_PUSH_OFFER,
);

export const SET_PRIMARY_CAR_REQUEST = util.requestType(SET_PRIMARY_CAR);
export const SET_PRIMARY_CAR_SUCCESS = util.successType(SET_PRIMARY_CAR);
export const SET_PRIMARY_CAR_FAILURE = util.failureType(SET_PRIMARY_CAR);

export const CAR_REQUEST = util.requestType(CAR);
export const CAR_SUCCESS = util.successType(CAR);
export const CAR_FAILURE = util.failureType(CAR);

export const USER_REQUEST = util.requestType(USER);
export const USER_SUCCESS = util.successType(USER);
export const USER_FAILURE = util.failureType(USER);

export const DEALER_REQUEST = util.requestType(DEALER);
export const DEALER_SUCCESS = util.successType(DEALER);
export const DEALER_FAILURE = util.failureType(DEALER);

export const PENCIL_REQUEST = util.requestType(PENCIL);
export const PENCIL_SUCCESS = util.successType(PENCIL);
export const PENCIL_FAILURE = util.failureType(PENCIL);

export const PENCIL_CREATE_REQUEST = util.requestType(PENCIL_CREATE);
export const PENCIL_CREATE_SUCCESS = util.successType(PENCIL_CREATE);
export const PENCIL_CREATE_FAILURE = util.failureType(PENCIL_CREATE);

export const PENCIL_UPDATE_REQUEST = util.requestType(PENCIL_UPDATE);
export const PENCIL_UPDATE_SUCCESS = util.successType(PENCIL_UPDATE);
export const PENCIL_UPDATE_FAILURE = util.failureType(PENCIL_UPDATE);

export const PENCIL_CRM_PUSH_REQUEST = util.requestType(PENCIL_CRM_PUSH);
export const PENCIL_CRM_PUSH_SUCCESS = util.successType(PENCIL_CRM_PUSH);
export const PENCIL_CRM_PUSH_FAILURE = util.failureType(PENCIL_CRM_PUSH);

export const PAYMENTS_REQUEST = util.requestType(PAYMENTS);
export const PAYMENTS_SUCCESS = util.successType(PAYMENTS);
export const PAYMENTS_FAILURE = util.failureType(PAYMENTS);
export const PAYMENTS_RESET = util.resetType(PAYMENTS);

export const SELECTED_CARS_REQUEST = util.requestType(SELECTED_CARS);
export const SELECTED_CARS_SUCCESS = util.successType(SELECTED_CARS);
export const SELECTED_CARS_FAILURE = util.failureType(SELECTED_CARS);
export const SELECTED_CARS_UPDATE_CAR = `${SELECTED_CARS}_UPDATE_CAR`;

export const PRINT_STICKER_REQUEST = util.requestType(PRINT_STICKER);
export const PRINT_STICKER_SUCCESS = util.successType(PRINT_STICKER);
export const PRINT_STICKER_FAILURE = util.failureType(PRINT_STICKER);

export const SEND_STICKER_REQUEST = util.requestType(SEND_STICKER);
export const SEND_STICKER_SUCCESS = util.successType(SEND_STICKER);
export const SEND_STICKER_FAILURE = util.failureType(SEND_STICKER);

export const FORWARD_TO_FNI_REQUEST = util.requestType(FORWARD_TO_FNI);
export const FORWARD_TO_FNI_SUCCESS = util.successType(FORWARD_TO_FNI);

export const FORWARD_TO_FNI_FAILURE = util.failureType(FORWARD_TO_FNI);

export const LOAD_DEAL_DATA_REQUEST = util.requestType(LOAD_DEAL_DATA);

export const SET_PENCIL = 'SET_PENCIL';
export const INIT_PENCIL = 'INIT_PENCIL';
export const UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS';

export const PUSHING_TO_CRM = 'PUSHING_TO_CRM';
export const PUSHING_TO_DMS = 'PUSHING_TO_DMS';

export const SET_PENCIL_MODAL_TEXT = 'SET_PENCIL_MODAL_TEXT';
export const UPDATE_TRADEINS_FOR_DMS = 'UPDATE_TRADEINS_FOR_DMS';
